import type { BatteryConcertAmountEligibilityDto } from "~/api/dto/battery-proposal.dto"

import { concertAmountBlockedPrompt as sharedConcertAmountBlockedPrompt } from "../../ProposalSetup/financing/concert/concert-amount-copy"

export {
  CONCERT_AMOUNT_CURRENT_LABEL,
  CONCERT_AMOUNT_NO_LIMIT,
  CONCERT_AMOUNT_NOT_PRICED,
  CONCERT_AMOUNT_RANGE_LABEL,
  concertAmountRangeText,
  formatConcertAmount,
  hasConfiguredConcertRange,
} from "../../ProposalSetup/financing/concert/concert-amount-copy"

/** Why Concert Battery is unavailable at this price; null when the amount is fine. */
export const concertAmountBlockedPrompt = (
  eligibility: BatteryConcertAmountEligibilityDto | null,
): string | null =>
  sharedConcertAmountBlockedPrompt(eligibility, `Concert Battery financing`)
